/* H&B wholesale intake: success means a durable record, never just an email attempt. */
(() => {
  const form = document.getElementById('HBWholesaleApplication');
  if (!form || form.dataset.savedIntakeBound) return;
  form.dataset.savedIntakeBound = 'true';
  const endpoint = form.dataset.intakeEndpoint;
  const status = form.querySelector('[data-intake-status]');
  const button = form.querySelector('button[type="submit"]');
  const key = 'hb-wholesale-submission-id';
  let submissionId;
  try { submissionId = sessionStorage.getItem(key); } catch (_) { /* Private browsing may disable storage. */ }
  if (!/^[a-f0-9-]{36}$/i.test(submissionId || '')) submissionId = crypto.randomUUID();
  const remember = () => { try { sessionStorage.setItem(key, submissionId); } catch (_) {} };
  remember();
  let busy = false;
  let done = false;
  let uncertainPayload = null;
  const show = (message, error = false) => {
    status.hidden = false;
    status.textContent = message;
    status.setAttribute('role', error ? 'alert' : 'status');
    status.className = error ? 'hb-intake-status hb-intake-status--error' : 'hb-intake-status';
    status.focus({ preventScroll: true });
    status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };
  const metric = (event) => {
    fetch(endpoint.replace(/\/applications$/, '/events'), {
      method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event }), keepalive: true,
    }).catch(() => {});
  };
  metric('view');
  form.addEventListener('input', () => metric('start'), { once: true });
  button.disabled = false;
  const loading = form.querySelector('[data-intake-loading]');
  if (loading) loading.hidden = true;
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy || done) return;
    if (!uncertainPayload && !form.reportValidity()) return;
    const data = new FormData(form);
    const value = (name) => String(data.get('contact[' + name + ']') || '').trim();
    const payload = uncertainPayload || {
      submissionId, company: value('Full company or business name'), contactName: value('name'),
      email: value('email'), phone: value('Phone'), website: value('Website'), storeType: value('Store type'),
      taxId: value('Tax ID or EIN'),
      address: { line1: value('Business shipping address line 1'), line2: value('Business shipping address line 2'),
        city: value('Business shipping city'), state: value('Business shipping state or province'),
        postalCode: value('Business shipping ZIP or postal code'), country: value('Business shipping country') },
      notes: value('body'), interests: '', agreement: data.get('contact[Resale confirmation]') === 'Confirmed',
      websiteTrap: String(data.get('company_fax') || ''),
    };
    busy = true;
    button.disabled = true;
    button.textContent = uncertainPayload ? 'Checking your application…' : 'Saving your application…';
    form.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(endpoint, { method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: controller.signal });
      const result = await response.json();
      if (!response.ok) {
        if (response.status >= 500) throw new Error('Unconfirmed');
        uncertainPayload = null;
        form.querySelectorAll('input, select, textarea').forEach((control) => { control.disabled = false; });
        if (response.status === 409) { submissionId = crypto.randomUUID(); remember(); }
        show(result.error || 'Please check the application details and try again.', true);
        return;
      }
      if (!result.reference) throw new Error('Unconfirmed');
      done = true;
      uncertainPayload = null;
      try { sessionStorage.removeItem(key); } catch (_) {}
      show('Thank you—your application is saved. Your reference is ' + result.reference + '. We’ll review it personally and follow up by email. Your application remains saved even if the confirmation email is delayed.');
      form.querySelectorAll('input, select, textarea').forEach((control) => { control.disabled = true; });
      button.textContent = 'Application received';
    } catch (_) {
      uncertainPayload = payload;
      form.querySelectorAll('input, select, textarea').forEach((control) => { control.disabled = true; });
      show('We couldn’t confirm the result because the connection was interrupted. Your details are still here. Choose “Check and retry” to safely check the same application—please keep this page open.', true);
    } finally {
      clearTimeout(timer);
      busy = false;
      form.removeAttribute('aria-busy');
      if (!done) { button.disabled = false; button.textContent = uncertainPayload ? 'Check and retry' : 'Submit wholesale application'; }
    }
  });
})();
